interface OfferPausedBannerProps {
  offerName?: string
}

/**
 * Composite admin pause (cap-api `offers.is_paused`) — mirrors OverflowBanner's locked
 * styling/placement so the two read as one visual language, but this is a stronger,
 * offer-wide freeze rather than an overflow-only state: give-up, cap requests and
 * overflow claims are all refused by the server while it's set, not only overflow draws.
 */
export function OfferPausedBanner({ offerName }: OfferPausedBannerProps) {
  return (
    <div className="mb-5 rounded-xl border px-4 py-3 border-amber-300/60 bg-amber-50 dark:border-amber-500/30 dark:bg-amber-500/10">
      <p className="text-sm font-semibold text-text-primary">
        {offerName ? `${offerName} is paused` : 'This offer is paused'}
      </p>
      <p className="text-xs text-text-muted mt-0.5 max-w-xl">
        This offer is currently paused. Cap requests and adjustments are unavailable until it
        resumes.
      </p>
    </div>
  )
}
